var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNafhubLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "nafhub-light",
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.502,
    height: 28,
    viewBox: "0 0 111.502 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M13.593,48.238c0-3.117-1.716-4.8-4.309-4.8s-4.379,1.682-4.379,4.8v10.72H0V39.55H4.905v2.417a7.252,7.252,0,0,1,5.85-2.7c4.519,0,7.742,2.943,7.742,8.3V58.959H13.593V48.24h0Z",
    transform: "translate(0 -31.833)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M113.258,39.27a7.664,7.664,0,0,1,6.405,3.081V39.586H124.6V58.978h-4.936V56.143a7.648,7.648,0,0,1-6.441,3.15c-4.9,0-8.822-4.027-8.822-10.081s3.92-9.941,8.856-9.941Zm1.259,4.3c-2.625,0-5.112,1.96-5.112,5.636s2.485,5.777,5.112,5.777,5.146-2.03,5.146-5.706S117.213,43.575,114.517,43.575Z",
    transform: "translate(-84.627 -31.833)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M222.748,7.8v-.8c0-2.165.8-2.932,3.176-2.862h0l.2,0V.018l-.2-.006h-.087C220.451-.1,217.79,2.1,217.79,6.819V27.133h4.956V11.809h3.386V7.8Z",
    transform: "translate(-176.542 -0.006)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M288.212,16.006V27.127h-4.364V16.792c0-3.434-1.36-5.1-4.157-5.1-2.924.051-4.475,1.725-4.475,4.841v10.6H270.9V0h4.121V8.008h.006v1.7a7.018,7.018,0,0,1,5.449-2.233h.1c2.917.034,5.042,1.091,6.318,3.144a10.429,10.429,0,0,1,1.32,5.384Z",
    transform: "translate(-219.593)",
    fill: "#889bd8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M385.354,39.82V50.833c0,3.04-1.542,4.672-4.456,4.722-2.814,0-4.125-1.585-4.125-4.989V39.82H371.79V51.371a10.612,10.612,0,0,0,1.413,5.6c1.343,2.108,3.549,3.218,6.561,3.3l.42.006v0a7.775,7.775,0,0,0,5.367-1.96v1.42h4.735V39.82Z",
    transform: "translate(-301.375 -32.278)",
    fill: "#889bd8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M491.528,7.451a7.823,7.823,0,0,0-6.534,3.142V0H479.96V27.551h5.034V24.659a7.8,7.8,0,0,0,6.568,3.214c5,0,9-4.106,9-10.282s-4-10.14-9.032-10.14Zm-1.286,16.03c-2.75,0-5.248-2.072-5.248-5.82s2.5-5.82,5.248-5.82,5.212,2,5.212,5.748S492.92,23.481,490.242,23.481Z",
    transform: "translate(-389.059)",
    fill: "#889bd8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNafhubLight);
export default __webpack_public_path__ + "static/media/nafhub-light.898f66a7c90bba52117bdb2e609a14ed.svg";
export { ForwardRef as ReactComponent };